import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { useAuth } from '@sine/auth-client';

import { authHelpers } from '../../authentication/auth.service';

export default function WithPermissionsCheck(Component: React.FC, role: string, pathName: string) {
  function WithPermission() {
    const [permitted, setPermitted] = useState<boolean | null>(null);
    const { authState } = useAuth();

    useEffect(() => {
      (async () => {
        if (authState === 'loggedIn') {
          await authHelpers.waitForPermissionsDefer();
          setPermitted(authHelpers.hasPermission(role));
        } else {
          setPermitted(false);
        }
      })().catch(console.error);
    }, [authState]);

    if (permitted === null) {
      return null;
    }

    if (!permitted) {
      return <Redirect to={pathName} />;
    }

    return <Component />;
  }

  return WithPermission;
}
